import {fromOffersCalculateResponse} from './mappers/from-offers-calculate-response'
import {toOffersCalculateRequest} from './mappers/to-offers-calculate-request'
import type {CreateOfferService} from './types'

export const createOfferService: CreateOfferService = dcaaRepository => {
  const {fetchOffersCalculate} = dcaaRepository

  return {
    fetchOffers(payload, selectedVertical, country) {
      const queryParams: Record<string, string> = {}

      if (country) {
        queryParams['country'] = country
      }

      if (payload.preOrderId) {
        queryParams['pre_order_id'] = payload.preOrderId
      }

      return fetchOffersCalculate(toOffersCalculateRequest(payload), queryParams)
        .then(fromOffersCalculateResponse)
        .then(response => {
          return response.filter(result => result.vertical === selectedVertical)
        })
    },
  }
}

export type {GetOffersPayload} from './types'
